<!-- Backdrop -->
<div
  class="notif-backdrop"
  *ngIf="sidebarVisible"
  (click)="close()"
></div>

<!-- Sidebar panel -->
<aside
  class="notif-sidebar"
  [class.notif-sidebar--open]="sidebarVisible"
  [class.notif-sidebar--left]="isRtl"
  [class.notif-sidebar--right]="!isRtl"
>
  <header class="notif-header">
    <div class="notif-header-left">
      <i class="fa-solid fa-bell notif-header-icon" aria-hidden="true"></i>
      <span class="notif-header-title">{{ "notifications" | translate }}</span>
      <span class="notif-header-badge" *ngIf="unreadCount > 0">
        {{ unreadCount > 99 ? '99+' : unreadCount }}
      </span>
    </div>
    <div class="notif-header-right">
      <button
        type="button"
        class="notif-mark-all-btn"
        (click)="markAllAsRead()"
        [disabled]="notifications.length === 0 || notificationsLoading"
      >
        <i class="fa-solid fa-check-double" aria-hidden="true"></i>
        <span>{{ "notifcation.DISMISS_ALL" | translate }}</span>
      </button>
      <button
        class="notif-close-btn"
        (click)="close()"
        type="button"
      >
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
    </div>
  </header>

  <div class="notif-body" (scroll)="onBodyScroll($event)">
    <div class="notif-loading" *ngIf="notificationsLoading">
      <div class="notif-loading-spinner"></div>
      <p>{{ "notifcation.LOADING" | translate }}</p>
    </div>

    <div class="notif-list" *ngIf="!notificationsLoading && notifications.length > 0">
      <div
        class="notif-item"
        [class.notif-item--unread]="!isNotificationRead(notification)"
        *ngFor="let notification of notifications; trackBy: trackByNotificationId"
        (click)="openNotificationDetails(notification)"
        (keydown.enter)="openNotificationDetails(notification)"
        tabindex="0"
        role="button"
      >
        <div class="notif-item-indicator" *ngIf="!isNotificationRead(notification)"></div>

        <div class="notif-item-icon" aria-hidden="true">
          <i class="fa-solid fa-bell"></i>
        </div>

        <div class="notif-item-content">
          <div class="notif-item-top">
            <h4 class="notif-item-title">{{ notification.title }}</h4>
            <time class="notif-item-time">
              {{ formatNotificationDate(notification.createdAt) }}
            </time>
          </div>
          <p class="notif-item-text" *ngIf="notification.description || notification.message">
            {{ notification.description || notification.message }}
          </p>
        </div>

        <button
          type="button"
          class="notif-item-action"
          (click)="markAsRead(notification.id); $event.stopPropagation()"
          *ngIf="!isNotificationRead(notification)"
          [title]="'notifcation.MARK_AS_READ' | translate"
        >
          <i class="fa-solid fa-check"></i>
        </button>
      </div>
    </div>

    <div class="notif-loading-more" *ngIf="loadingMore">
      <div class="notif-loading-spinner notif-loading-spinner--sm"></div>
    </div>

    <div class="notif-empty" *ngIf="!notificationsLoading && notifications.length === 0">
      <div class="notif-empty-illustration">
        <i class="fa-regular fa-bell-slash"></i>
      </div>
      <p class="notif-empty-title">{{ "notifcation.EMPTY_TITLE" | translate }}</p>
      <p class="notif-empty-sub">{{ "notifcation.EMPTY_SUBTITLE" | translate }}</p>
    </div>
  </div>
</aside>

<!-- Detail Dialog -->
<p-dialog
  [(visible)]="notificationDetailVisible"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [showHeader]="false"
  [baseZIndex]="20000"
  appendTo="body"
  styleClass="notif-dialog"
  (onHide)="selectedNotification = null"
>
  <div class="notif-dialog-content" *ngIf="selectedNotification">
    <div class="notif-dialog-top-icon">
      <i class="fa-solid fa-bell"></i>
    </div>

    <h2 class="notif-dialog-title">{{ selectedNotification.title }}</h2>

    <time class="notif-dialog-time">
      {{ formatNotificationDate(selectedNotification.createdAt) }}
    </time>

    <div class="notif-dialog-divider"></div>

    <p class="notif-dialog-text" *ngIf="selectedNotification.description">
      {{ selectedNotification.description }}
    </p>
    <p class="notif-dialog-text" *ngIf="selectedNotification.message">
      {{ selectedNotification.message }}
    </p>

    <div class="notif-dialog-actions">
      <button
        type="button"
        class="notif-dialog-btn notif-dialog-btn--outline"
        *ngIf="!isNotificationRead(selectedNotification)"
        (click)="selectedNotification && markAsRead(selectedNotification.id)"
      >
        <i class="fa-solid fa-check"></i>
        {{ "notifcation.MARK_AS_READ" | translate }}
      </button>
      <button
        type="button"
        class="notif-dialog-btn notif-dialog-btn--primary"
        (click)="notificationDetailVisible = false"
      >
        {{ "COMMON.CLOSE" | translate }}
      </button>
    </div>
  </div>
</p-dialog>
